import { type Signal, signal } from "@preact/signals-react";

export type GenericObject = { [key: string]: unknown };

export const context: Signal<GenericObject> = signal({});
